<template>
  <div v-if="isEnabled" class="p-2 text-white" style="--bs-columns: 2; background: rgba(30,30,30, 0.8)">
    <template v-for="count in shownCounts">
      <div v-if="count.condition || count.condition === undefined"
        v-tooltip="{ content: $t(count.tooltip), placement: 'left' }" class="voter-counts-grid">
        <AVIcon :icon="count.icon" />
        <AVTweenedCount :id="countId(count.tooltip)" :count="count.count" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useSharedStore } from "@/entrypoints/stores/shared";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import type { VoterCountKey } from "@/types";

const sharedStore = useSharedStore();

const presentationStore = usePresentationStore();

const ballotOpen = computed(() => presentationStore.activeSlide
  && presentationStore.activeSlide.type === "Slides::BallotSlide"
  && ["open", "countdown"].includes(presentationStore.activeSlide.state)
);

const isEnabled = computed(() => sharedStore.election.voterCountsConfig
  && sharedStore.election.voterCountsConfig.enabled
  && shownCounts.value.length > 0
);

const shownCounts = computed(() => sharedStore.election.voterCountsConfig
  && sharedStore.election.voterCountsConfig.shownCounts.map((c: VoterCountKey) => countInfo(c))
);

const countInfo = (key: VoterCountKey) => {
  switch (key) {
    case "active_eligibles":
      return {
        icon: "person-booth",
        count: presentationStore.voterCounts.activeEligibles,
        tooltip: "js.voter_counts.active_eligibles",
        condition: ballotOpen,
      }
    case "active_eligibles_weight":
      return {
        icon: "weight-hanging",
        count: presentationStore.voterCounts.activeEligiblesWeight,
        tooltip: "js.voter_counts.active_eligibles_weight",
        condition: ballotOpen,
      }
    case "active_voters":
      return {
        icon: "eye",
        count: presentationStore.voterCounts.activeVoters,
        tooltip: "js.voter_counts.active_voters",
      }
    case "total_voters":
      return {
        icon: "users",
        count: presentationStore.voterCounts.totalVoters,
        tooltip: "js.voter_counts.total_voters",
      }
  }
};

const countId = (longkey: string) => longkey.split(".").pop();
</script>

<style scoped>
.voter-counts-grid {
  display: grid;
  grid-template-columns: 2fr 2fr;
  place-items: center;
  gap: 0.5rem;
}
</style>
